export enum LinkDisplayType {
    all,
    auth,
    unauth
}
